//#region Imports
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
//MUI
import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, Box, CircularProgress, Grid, Typography, FormControl, Select, MenuItem, ListItemIcon, ListItemText, Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import IESCODDLOGO from '../../../images/discologos/iesco logo.png'
import FESCODDLOGO from '../../../images/discologos/fesco.jpg'
import GEPCODDLOGO from '../../../images/discologos/gepco.jpg'
import HAZECODDLOGO from '../../../images/discologos/hazeco_logo-removebg-preview.png'
import HESCODDLOGO from '../../../images/discologos/hesco logo.png'
import LESCODDLOGO from '../../../images/discologos/lesco.jpg'
import MEPCODDLOGO from '../../../images/discologos/mepco1.jpg'
import PESCODDLOGO from '../../../images/discologos/pesco1.jpg'
import PITCDDLOGO from '../../../images/discologos/pitc11-removebg-preview.png'
import QESCODDLOGO from '../../../images/discologos/qesco.png'
import SEPCODDLOGO from '../../../images/discologos/sepco.jpg'
import TESCODDLOGO from '../../../images/discologos/tesco.jpg'
//scss
import "../../../style/common.scss";
// use scan detection
import useScanDetection from 'use-scan-detection';
// authorization
// Services
//jspdf
//jsbarcode
import { useDispatch, useSelector } from 'react-redux';
import BasicTable from '../../../components/basicTable/basicTable';
import { fetchPaginatedEscalatedComplaints, firstPage, lastPage, nextPage, previousPage } from '../../../features/powerComplaints/escalatedComplaintsSlice';
import { tableStyle } from '../../../style/common';
import { IconButton } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { convertDateYYYYMMDD, convertDatewithTime, subdivisionName, toTitleCase, convertDate, getName } from '../../../services/Functions';
import { cfpBaseUrl, wfsBaseUrl } from '../../../network/urls';
import excel from '../../../images/excel.png';
import pdf from '../../../images/pdf.png';
import print from '../../../images/print.png';
import { internalIconStyles } from '../../../style/common';
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../../images/pitc.png';
import eOpsLogo from '../../../images/eops.png';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
//#endregion

const EscalatedComplaints = ({ selectedItem, hrc }) => {

    //#region initial values

    let ComplaintStatusBarArray = [
        {
            title1: 'COMPLAINT',
            title2: 'RECEIVED',
        },
        {
            title1: 'ASSIGNED TO',
            title2: 'FIELD STAFF',
        },
        {
            title1: 'COMPLAINT',
            title2: 'RESOLVED',
        },
        {
            title1: 'COMPLAINT',
            title2: 'CLOSED',
        },
        {
            title1: 'REOPENED BY',
            title2: 'CALL CENTER',
        }
    ]

    //#endregion

    //#region get item local storage 
    const { code, token, roleId, roleName, name, hierarchy: userHierarchy, cfcLevelId, cscID, roleTypeName, permissions, userId } = useSelector((state) => state.auth)
    const offCode = userHierarchy == 1
        ? code
        : userHierarchy == 2
            ? code.slice(0, 2)
            : userHierarchy == 3
                ? code.slice(0, 3)
                : userHierarchy == 4
                    ? code.slice(0, 4)
                    : userHierarchy == 5
                        ? code.slice(0, 5)
                        : code;
    const companyCode = code.slice(0, 2)
    const [selectedCompanyCode, setSelectedCompanyCode] = useState('');
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedSubDivision, setSelectedSubDivision] = useState('');
    const [subDivisions, setSubDivisions] = useState(JSON.parse(window.localStorage.getItem('subDivisions')) || []);
    const [officeCode, setOfficeCode] = useState('');
    const [officeName, setOfficeName] = useState('');
    const [apiData, setApiData] = useState([]);
    const [circleName, setCircleName] = useState('');
    const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
    const [hierarchy, setHierarchy] = useState('');
    const [filteredDivisions, setFilteredDivisions] = useState([]);
    const [filteredCircles, setFilteredCircles] = useState([]);
    const [circleCode, setCircleCode] = useState('');
    const [isGoDisabled, setIsGoDisabled] = useState(false);
const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
    const getCompanies = (code) => {
        switch (code) {
            case '10':
                return 'Power Information Technology Company';
            case '11':
                return 'Lahore Electric Supply Company';
            case '12':
                return 'Gujranwala Electric Power Company';
            case '13':
                return 'Faisalabad Electric Supply Company';
            case '14':
                return 'Islamabad Electric Supply Company';
            case '15':
                return 'Multan Electric Power Company';
            case '26':
                return 'Peshawar Electric Supply Company';
            case '27':
                return 'Hazara Electric Supply Company';
            case '37':
                return 'Hyderabad Electric Supply Company';
            case '38':
                return 'Sukkur Electric Power Company';
            case '48':
                return 'Quetta Electric Supply Company';
            case '59':
                return 'Tribal Electric Supply Company';
            default:
                return '';
        }
    };
    const getLogo = (code) => {
        switch (code) {
            case '10':
                return pitcLogo
            case '11':
                return LESCOLOGO
            case '12':
                return GEPCOLOGO
            case '13':
                return FESCOLOGO
            case '14':
                return IESCOLOGO
            case '15':
                return MEPCOLOGO
            case '26':
                return PESCOLOGO
            case '27':
                return HAZECOLOGO
            case '37':
                return HESCOLOGO
            case '38':
                return SEPCOLOGO
            case '48':
                return QESCOLOGO
            case '59':
                return TESCOLOGO
            default:
                return MEPCOLOGO
        }
    }
    const dispatch = useDispatch();
    const { pageNumber, pageSize, status: complaintStatus, data, totalPages, totalRecords, isLoading } = useSelector((state) => state.escalatedComplaintsPaginated)


    //#endregion

    //#region states 

    const [complainDetails, setComplainDetails] = useState({
        createdOn: '',
        complainStatus: '',
        complainSource: '',
        complaintDetail: '',
        escLevel: '',
        escOpen: ''

    })
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are 0-indexed
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const [partialValue, setPartialValue] = useState('');
    const [powerComplaints, setPowerComplaints] = useState([]);
    const [sortOrder, setSortOrder] = useState(null);

    const [powerComplaintsToDataGrid, setPowerComplaintsToDataGrid] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const { state } = useLocation();
    const { foundId } = state ? state : '';
    const [foundInNc, setFoundInNc] = useState();
    const [duration, setDuration] = useState(3);
    const [dateFrom, setDateFrom] = useState(getCurrentDate)
    const [dateTo, setDateTo] = useState(getCurrentDate());
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const { wmsPrivateToken } = useSelector(state => state.auth)

    //#endregion

    //#region constants / variables 


    var remarksToSave = "";

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    let dateTill = new Date();
    dateTill.setDate(1);
    const monthUpto = currentMonth - duration
    dateTill.setMonth(monthUpto);
    dateTill.setHours(0, 0, 0, 0);


    const subdivisionName = (code) => {
        if (code) {
            let subdivisionName = '';
            if (code !== 99999) {
                subdivisionName = subDivisions.find(item => item.subDivisionCode === code).subDivisionName
            }
            else {
                subdivisionName = code
            }
            return subdivisionName
        }
    }

    const companies = [
        { code: "11", name: "LESCO", logo: LESCODDLOGO },
        { code: "12", name: "GEPCO", logo: GEPCODDLOGO },
        { code: "13", name: "FESCO", logo: FESCODDLOGO },
        { code: "14", name: "IESCO", logo: IESCODDLOGO },
        { code: "15", name: "MEPCO", logo: MEPCODDLOGO },
        { code: "26", name: "PESCO", logo: PESCODDLOGO },
        { code: "27", name: "HAZECO", logo: HAZECODDLOGO },
        { code: "37", name: "HESCO", logo: HESCODDLOGO },
        { code: "38", name: "SEPCO", logo: SEPCODDLOGO },
        { code: "48", name: "QESCO", logo: QESCODDLOGO },
        { code: "59", name: "TESCO", logo: TESCODDLOGO },
    ];
    function formatDate(dateString) {
        const date = new Date(dateString);

        // Get components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        // Format as desired
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }

    useScanDetection({
        onComplete: async (code) => {
            if (code) {
                code = code.replace(/Shift/g, '');
                const regex = /^[A-Z]{2}-\d{14,15}$/;
                if (regex.test(code)) {
                    await handleRowClick(code);
                } else {
                    console.warn('Invalid code format:', code);
                }
            }
        },
        minLength: 4, // EAN13
    });

    const handleClose = () => {
        //applied load field
        setOpen(false);
    };

    const filterNCApp = (applicationId) => {
        const myArray = powerComplaints
        let itemFound = myArray.find(item => item.complaintId === applicationId)
        return itemFound;
    }

    const apiToDataGridConversion = () => {
        const tempArray = [];

        if (powerComplaints && powerComplaints.length > 0) {
            const sortedComplaints = [...powerComplaints].sort((a, b) => a.Serial_No - b.Serial_No);

            sortedComplaints.forEach((item) => {
                if (item.EOpsTrackingId) {  
                    const dataGridObject = {
                        srNo: item.Serial_No,
                        complaintId: item.EOpsTrackingId,
                        refNo: item.RefNo,
                        name: item.Name,
                        address: item.Address,
                        phoneNo: item.Mobile,
                        registerdDateTime: formatDate(item.RegisteredAt),
                        escalatedTo: item.EscalatedTo,
                        elapsedTime: item.elapsedTime,
                    };
                    tempArray.push(dataGridObject);
                }
            });
        }

        setPowerComplaintsToDataGrid(tempArray);
    };



    const handleRowClick = async (applicationId, event) => {
        if (applicationId) {
            const item = filterNCApp(applicationId);
            if (item) {
                var myHeaders = new Headers();
                myHeaders.append("Cookie", "ccms_session=eyJpdiI6InZZSTNqeVVYNE50MjFEeUJGMHFDbkE9PSIsInZhbHVlIjoiTlwvc1NaSGpSOGNMWDNvQ0VtVXcwWUV0b2pZa2ZITmlZbmErenRtc1ZJc2ZnSUluaTBPajNCWEJCR3dlcnlwQmIiLCJtYWMiOiJhMDFiOTM5NDA3NDA4NTUwOWVkZjVlZWQxYmU3MTQ5YWRkYmNjYzE2YjJhYjE1MmZhZTU5ZTUzYzIwNmRkNzQ0In0%3D");

                var requestOptions = {
                    method: 'GET',
                    headers: myHeaders,
                    headers: myHeaders,
                    redirect: 'follow',
                };

                await fetch(`http://ccms.pitc.com.pk/api/complaints/mobile/+${applicationId}`, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.COMPLAINT_SEARCH[0].RECORD_FOUND === "TRUE") {
                            setComplainDetails(
                                {
                                    createdOn: result.COMPLAINT_SEARCH[1].created_on,
                                    complainStatus: result.COMPLAINT_SEARCH[1].ComplaintStatus,
                                    complainSource: result.COMPLAINT_SEARCH[1].complaint_source,
                                    complaintDetail: result.COMPLAINT_SEARCH[1].complaint_detail,
                                    escLevel: result.COMPLAINT_SEARCH[1].esc_level_id,
                                    escOpen: result.COMPLAINT_SEARCH[1].esc_reopen

                                })
                        }

                    })
                    .catch(error => console.log('error', error));
                setDialogRowData(item);
                setOpen(true);
            }
        }
    };


    const handleNextPage = () => {
        setViewBackdrop(true);
        dispatch(
            fetchPaginatedEscalatedComplaints({
                pageNumber: pageNumber + 1,
                pageSize,
                subDivisionCode: officeCode || offCode, // Use officeCode if available, else offCode
                status: complaintStatus,
                dateFrom: convertDateYYYYMMDD(dateFrom),
                dateTo: convertDateYYYYMMDD(dateTo),
            })
        );
    };

    const handlePreviousPage = () => {
        if (pageNumber > 1) {
            setViewBackdrop(true);
            dispatch(
                fetchPaginatedEscalatedComplaints({
                    pageNumber: pageNumber - 1,
                    pageSize,
                    subDivisionCode: officeCode || offCode, // Use officeCode if available, else offCode
                    status: complaintStatus,
                    dateFrom: convertDateYYYYMMDD(dateFrom),
                    dateTo: convertDateYYYYMMDD(dateTo),
                })
            );
        }
    };

    const handleFirstPage = () => {
        setViewBackdrop(true);
        dispatch(
            fetchPaginatedEscalatedComplaints({
                pageNumber: 1,
                pageSize,
                subDivisionCode: officeCode || offCode, // Use officeCode if available, else offCode
                status: complaintStatus,
                dateFrom: convertDateYYYYMMDD(dateFrom),
                dateTo: convertDateYYYYMMDD(dateTo),
            })
        );
    };

    const handleLastPage = () => {
        setViewBackdrop(true);
        dispatch(
            fetchPaginatedEscalatedComplaints({
                pageNumber: totalPages,
                pageSize,
                subDivisionCode: officeCode || offCode, // Use officeCode if available, else offCode
                status: complaintStatus,
                dateFrom: convertDateYYYYMMDD(dateFrom),
                dateTo: convertDateYYYYMMDD(dateTo),
            })
        );
    };
    //#endregion

    //#endregion

    //#region formiks

    //#endregion

    //#region useEffects

    useEffect(() => {
        if (powerComplaints) {
            apiToDataGridConversion()
        }
    }, [powerComplaints]);

    useEffect(() => {
        if (foundId && foundId != '') {
            setFoundInNc(foundId)
        }
    }, [foundId])

    useEffect(() => {
        if (foundInNc) {
            let allApps = JSON.parse(window.localStorage.getItem('power-complaints'));

            if (allApps) {
                setPowerComplaints(allApps)
            }
        }
    }, [foundInNc])

    useEffect(() => {
        if (powerComplaints.length >= 1) {
            if (foundInNc && foundInNc != '') {


                const ncApp = powerComplaints.find(item => item.applicationId === foundInNc)

                handleRowClick(foundInNc)
                // setDialogRowData(ncApp)
                // setOpen(true)
            }
        }
    }, [powerComplaints])
    const fetchData = (pageNumber, pageSize, subDivisionCode, status, dateFrom, dateTo) => {
        setViewBackdrop(true);
        dispatch(
            fetchPaginatedEscalatedComplaints({
                pageNumber,
                pageSize,
                subDivisionCode: subDivisionCode || offCode, // Use provided subDivisionCode or fall back to offCode
                status,
                dateFrom,
                dateTo,
            })
        );
    };

    useEffect(() => {
        if (data && Array.isArray(data)) {
            const sortedComplaints = [...data].sort((a, b) => {
                const currentDate = new Date();
                const dateA = new Date(a.RegisteredAt);
                const dateB = new Date(b.RegisteredAt);

                const diffA = Math.abs(currentDate - dateA);
                const diffB = Math.abs(currentDate - dateB);

                return diffB - diffA;
            });

            setPowerComplaints(sortedComplaints);
            setViewBackdrop(false);
        }
    }, [data]);
    //#endregion
    const handleSort = (order) => {

        const sortedData = [...powerComplaints].sort((a, b) => {
            const dateA = new Date(a.RegisteredAt);
            const dateB = new Date(b.RegisteredAt);

            if (order === "asc") {
                return dateA - dateB;
            } else {
                return dateB - dateA;
            }
        });

        setPowerComplaints(sortedData);
        setSortOrder(order);
    };
    const tblColumns = [
        { field: "srNo", headerName: 'Sr No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintId", headerName: 'Complaint ID', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "refNo", headerName: 'Ref No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "phoneNo", headerName: ' Phone No.', disableColumnMenu: true, sortable: false, filterable: false, align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            field: "registerdDateTime",
            headerName: (
                <Box display="flex" alignItems="center" gap={1}>
                    <span>Registered At</span>
                    <IconButton onClick={() => handleSort("asc")} size="small">
                        <ArrowUpwardIcon sx={{ color: sortOrder === "asc" ? "white" : "inherit" }} />
                    </IconButton>
                    <IconButton onClick={() => handleSort("desc")} size="small">
                        <ArrowDownwardIcon sx={{ color: sortOrder === "desc" ? "white" : "inherit" }} />
                    </IconButton>
                </Box>
            ),
            valueGetter: (params) => params.row.RegisteredAt, align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle
        },
        { field: "escalatedTo", headerName: 'Escalated to', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
         { field: "elapsedTime", headerName: ' Elapsed Time', disableColumnMenu: true, sortable: false, filterable: false, align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

    ]
    // Fetch subDivisions for code == 10
    useEffect(() => {
        if (code == 10 && selectedCompanyCode) {
            const fetchSubDivisions = async () => {
                setViewBackdrop(true);
                const myHeaders = new Headers();
                myHeaders.append('Authorization', token);
                const formdata = new FormData();
                formdata.append('companyCode', selectedCompanyCode);
                const requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: formdata,
                    redirect: 'follow',
                };
                try {
                    const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
                    if (response.ok) {
                        const result = await response.json();
                        if (result.status === '200') {
                            setSubDivisions(result.message);
                            setApiData(result.message);
                            // Populate circles
                            const circles = result.message.reduce((acc, curr) => {
                                if (!acc.some(item => item.circleCode === curr.circleCode)) {
                                    acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                                }
                                return acc;
                            }, []);
                            setFilteredCircles(circles);
                        } else {
                            console.error('Error fetching subDivisions:', result.message);
                            setSubDivisions([]);
                            setFilteredCircles([]);
                        }
                    } else {
                        throw new Error(`Request failed with status ${response.status}`);
                    }
                } catch (error) {
                    console.error('Error fetching subDivisions:', error);
                    setSubDivisions([]);
                    setFilteredCircles([]);
                } finally {
                    setViewBackdrop(false);
                }
            };
            fetchSubDivisions();
        } else if (code != 10) {
            // For code != 10, populate circles from localStorage subDivisions
            const circles = subDivisions.reduce((acc, curr) => {
                if (!acc.some(item => item.circleCode === curr.circleCode)) {
                    acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                }
                return acc;
            }, []);
            setFilteredCircles(circles);
        }
    }, [code, selectedCompanyCode, token, cfpBaseUrl]);

    const handleChangeCompany = async (e) => {
        const selectedCompany = e.target.value;
        setSelectedCompanyCode(selectedCompany);
        setOfficeCode(selectedCompany);
        setOfficeName(getCompanies(selectedCompany) || '');

        if (code == 10 && selectedCompany) {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append('Authorization', token);
            const formdata = new FormData();
            formdata.append('companyCode', selectedCompany);
            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow',
            };

            try {
                const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
                if (response.ok) {
                    const result = await response.json();
                    if (result.status === '200') {
                        setSubDivisions(result.message);
                        setApiData(result.message);

                        // Reset dropdowns
                        setCircleCode('');
                        setSelectedDivision('');
                        setSelectedSubDivision('');
                        setCircleName('');
                        setFilteredDivisions([]);
                        setFilteredSubDivisions([]);

                        // Populate circles
                        const circles = result.message.reduce((acc, curr) => {
                            if (!acc.some(item => item.circleCode === curr.circleCode)) {
                                acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                            }
                            return acc;
                        }, []);
                        setFilteredCircles(circles);
                    } else {
                        console.error('Error fetching subDivisions:', result.message);
                        setSubDivisions([]);
                        setFilteredCircles([]);
                    }
                } else {
                    throw new Error(`Request failed with status ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching subDivisions:', error);
                setSubDivisions([]);
                setFilteredCircles([]);
            } finally {
                setViewBackdrop(false);
            }
        } else if (!selectedCompany) {
            // Reset when no company is selected
            setOfficeName('PITC');
            setCircleCode('');
            setSelectedDivision('');
            setSelectedSubDivision('');
            setCircleName('');
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);
            setFilteredCircles([]);
            setSubDivisions([]);
            setApiData([]);
        }
    };

    const handleCircleChange = async (event) => {
        const selectedCircleCode = event.target.value ? parseInt(event.target.value) : '';
        if (code == 10 && selectedCircleCode && selectedCompanyCode) {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append('Authorization', token);
            const formdata = new FormData();
            formdata.append('companyCode', selectedCompanyCode);
            formdata.append('circleCode', selectedCircleCode);
            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow',
            };

            try {
                const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
                if (response.ok) {
                    const result = await response.json();
                    if (result.status === '200') {
                        setSubDivisions(result.message);
                        setApiData(result.message);

                        setCircleCode(selectedCircleCode);
                        setOfficeCode(selectedCircleCode);
                        const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
                        const circleName = circle?.circleName || '';
                        setOfficeName(circleName.concat(' Circle'));
                        setCircleName(circleName);
                        setSelectedDivision('');
                        setSelectedSubDivision('');
                        setFilteredSubDivisions([]);

                        // Populate divisions
                        const uniqueDivisions = result.message
                            .filter(item => item.circleCode === selectedCircleCode)
                            .reduce((acc, item) => {
                                if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                                    acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                                }
                                return acc;
                            }, []);
                        setFilteredDivisions(uniqueDivisions);
                    } else {
                        console.error('Error fetching subDivisions:', result.message);
                        setSubDivisions([]);
                        setFilteredDivisions([]);
                    }
                } else {
                    throw new Error(`Request failed with status ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching subDivisions:', error);
                setSubDivisions([]);
                setFilteredDivisions([]);
            } finally {
                setViewBackdrop(false);
            }
        } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
            // Handle "All Circle" selection for code == 10
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append('Authorization', token);
            const formdata = new FormData();
            formdata.append('companyCode', selectedCompanyCode);
            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow',
            };

            try {
                const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
                if (response.ok) {
                    const result = await response.json();
                    if (result.status === '200') {
                        setSubDivisions(result.message);
                        setApiData(result.message);

                        setCircleCode('');
                        setOfficeCode(selectedCompanyCode);
                        setOfficeName(getCompanies(selectedCompanyCode));
                        setCircleName('');
                        setSelectedDivision('');
                        setSelectedSubDivision('');
                        setFilteredSubDivisions([]);

                        // Populate divisions
                        const uniqueDivisions = result.message.reduce((acc, item) => {
                            if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                            }
                            return acc;
                        }, []);
                        setFilteredDivisions(uniqueDivisions);
                    } else {
                        console.error('Error fetching subDivisions:', result.message);
                        setSubDivisions([]);
                        setFilteredDivisions([]);
                    }
                } else {
                    throw new Error(`Request failed with status ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching subDivisions:', error);
                setSubDivisions([]);
                setFilteredDivisions([]);
            } finally {
                setViewBackdrop(false);
            }
        } else if (selectedCircleCode) {
            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
            const circleName = circle?.circleName || '';
            setOfficeName(circleName.concat(' Circle'));
            setCircleName(circleName);
            setSelectedDivision('');
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);
            const uniqueDivisions = subDivisions
                .filter(item => item.circleCode === selectedCircleCode)
                .reduce((acc, item) => {
                    if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                        acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                    }
                    return acc;
                }, []);
            setFilteredDivisions(uniqueDivisions);
        } else {
            // Handle "All Circle" for code != 10
            setCircleCode('');
            setSelectedDivision('');
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);
            if (roleTypeName == 'Technical') {
                if (offCode) {
                    setOfficeCode(offCode == 10 ? 15 : offCode);
                    let officeName = getName(offCode == 10 ? '15' : offCode.toString(), subDivisions);
                    setOfficeName(officeName.concat(' Region'));
                    setCircleName('');
                    const circles = subDivisions.reduce((acc, curr) => {
                        if (!acc.some(item => item.circleCode === curr.circleCode)) {
                            acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                        }
                        return acc;
                    }, []);
                    setFilteredCircles(circles);
                    const uniqueDivisions = subDivisions.reduce((acc, item) => {
                        if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                        }
                        return acc;
                    }, []);
                    setFilteredDivisions(uniqueDivisions);
                }
            } else if (roleTypeName == 'Commercial') {
                if (cfcLevelId == 2) {
                    if (offCode) {
                        setOfficeCode(offCode.toString().slice(0, 2));
                        let offName = cscID;
                        setOfficeName(offName);
                        setHierarchy(cfcLevelId);
                        const uniqueDivisions = subDivisions.reduce((acc, item) => {
                            if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                            }
                            return acc;
                        }, []);
                        setFilteredDivisions(uniqueDivisions);
                    }
                } else if (cfcLevelId == 3) {
                    if (offCode) {
                        setOfficeCode(offCode.toString().slice(0, 3));
                        let offName = cscID;
                        setOfficeName(offName);
                        setHierarchy(cfcLevelId);
                        const uniqueDivisions = subDivisions.reduce((acc, item) => {
                            if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                            }
                            return acc;
                        }, []);
                        setFilteredDivisions(uniqueDivisions);
                    }
                }
            }
        }
    };

    const handleDivisionChange = async (e) => {
        const selectedDivisionCode = parseInt(e.target.value);
        if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append('Authorization', token);
            const formdata = new FormData();
            formdata.append('companyCode', selectedCompanyCode);
            formdata.append('divisionCode', selectedDivisionCode);
            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow',
            };

            try {
                const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
                if (response.ok) {
                    const result = await response.json();
                    if (result.status === '200') {
                        setSubDivisions(result.message);
                        setApiData(result.message);

                        setSelectedDivision(selectedDivisionCode);
                        setOfficeCode(selectedDivisionCode);
                        const division = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode);
                        const divisionName = division?.divisionName || '';
                        setOfficeName(divisionName.concat(' Division'));
                        setSelectedSubDivision('');
                        const uniqueSubDivisions = result.message
                            .filter(item => item.divisionCode == selectedDivisionCode)
                            .reduce((acc, item) => {
                                if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                                    acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
                                }
                                return acc;
                            }, []);
                        setFilteredSubDivisions(uniqueSubDivisions);
                    } else {
                        console.error('Error fetching subDivisions:', result.message);
                        setSubDivisions([]);
                        setFilteredSubDivisions([]);
                    }
                } else {
                    throw new Error(`Request failed with status ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching subDivisions:', error);
                setSubDivisions([]);
                setFilteredSubDivisions([]);
            } finally {
                setViewBackdrop(false);
            }
        } else if (selectedDivisionCode) {
            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const divisionName = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode)?.divisionName || '';
            setOfficeName(divisionName.concat(' Division'));
            setSelectedSubDivision('');
            const uniqueSubDivisions = subDivisions
                .filter(item => item.divisionCode == selectedDivisionCode)
                .reduce((acc, item) => {
                    if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                        acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
                    }
                    return acc;
                }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
        } else {
            setSelectedDivision('');
            setOfficeCode(circleCode ? circleCode : offCode);
            let officeName = getName(circleCode ? circleCode.toString() : offCode.toString(), subDivisions);
            setOfficeName(officeName.concat(' Circle'));
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);
            const uniqueDivisions = subDivisions
                .filter(item => item.circleCode == (circleCode ? circleCode : offCode))
                .reduce((acc, item) => {
                    if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                        acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                    }
                    return acc;
                }, []);
            setFilteredDivisions(uniqueDivisions);
        }
    };

    const handleSubDivisionChange = async (e) => {
        const selectedSubDivisionCode = parseInt(e.target.value);
        if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append('Authorization', token);
            const formdata = new FormData();
            formdata.append('companyCode', selectedCompanyCode);
            formdata.append('subDivisionCode', selectedSubDivisionCode);
            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow',
            };

            try {
                const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
                if (response.ok) {
                    const result = await response.json();
                    if (result.status === '200') {
                        setSubDivisions(result.message);
                        setApiData(result.message);

                        setSelectedSubDivision(selectedSubDivisionCode);
                        setOfficeCode(selectedSubDivisionCode);
                        const subDivision = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode);
                        const subDivisionName = subDivision?.subDivisionName || '';
                        setOfficeName(subDivisionName.concat(' Sub Division'));
                    } else {
                        console.error('Error fetching subDivisions:', result.message);
                        setSubDivisions([]);
                    }
                } else {
                    throw new Error(`Request failed with status ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching subDivisions:', error);
                setSubDivisions([]);
            } finally {
                setViewBackdrop(false);
            }
        } else if (selectedSubDivisionCode) {
            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivisionName = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode)?.subDivisionName || '';
            setOfficeName(subDivisionName.concat(' Sub Division'));
        } else {
            setSelectedSubDivision('');
            let officeName = getName(selectedDivision ? selectedDivision.toString() : offCode.toString(), subDivisions);
            setOfficeName(officeName.concat(' Division'));
            setOfficeCode(selectedDivision ? selectedDivision : offCode);
        }
    };

    useEffect(() => {
        if (roleTypeName == 'Technical') {
            if (offCode) {
                setOfficeCode(offCode == 10 ? 15 : offCode);
                let offName = getName(offCode == 10 ? '15' : offCode.toString(), subDivisions);
                setOfficeName(offName);
                setHierarchy(offCode.toString().length);
            }
        } else if (roleTypeName == 'Commercial') {
            if (cfcLevelId == 1) {
                if (offCode) {
                    if (offCode == 10) {
                        setOfficeCode(15);
                        setOfficeName("PITC");
                    } else {
                        setOfficeCode(offCode);
                        let offName = getName(offCode, subDivisions);
                        setOfficeName(offName);
                    }

                    setHierarchy(offCode.length);
                }
            } else if (cfcLevelId == 2) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 2));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            } else if (cfcLevelId == 3) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 3));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            } else if (cfcLevelId == 4 || cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
        }
    }, [offCode, cfcLevelId, roleTypeName, cscID]);

    useEffect(() => {
        if (hierarchy) {
            if (hierarchy == 1 || cfcLevelId === 1) {
                console.log('1 wala if');
                let circles = subDivisions.reduce((acc, curr) => {
                    if (!acc.some(item => item.circleCode === curr.circleCode)) {
                        acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                    }
                    return acc;
                }, []);
                setFilteredCircles(circles);
            } else if (hierarchy == 2 || cfcLevelId == 2) {
                console.log('2 wala if');
                let circles = subDivisions.reduce((acc, curr) => {
                    if (!acc.some(item => item.circleCode === curr.circleCode)) {
                        acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                    }
                    return acc;
                }, []);
                setFilteredCircles(circles);
            } else if (hierarchy == 3 || cfcLevelId == 3) {
                console.log('3 wala if');
                setCircleCode(offCode.slice(0, 3));
                console.log(offCode.slice(0, 3), 'djlsahjdhalhdalhlkd');
                const uniqueDivisions = subDivisions
                    .filter(item => item.circleCode == offCode.slice(0, 3))
                    .reduce((acc, item) => {
                        if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                        }
                        return acc;
                    }, []);
                setFilteredDivisions(uniqueDivisions);
            } else if ((hierarchy == 4 || cfcLevelId == 4) || (hierarchy == 5 || cfcLevelId == 5)) {
                console.log('4 wala if');
                setSelectedDivision(offCode.slice(0, 4));
                const uniqueSubDivisions = subDivisions
                    .filter(item => item.divisionCode == offCode.slice(0, 4))
                    .reduce((acc, item) => {
                        if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                            acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
                        }
                        return acc;
                    }, []);
                setFilteredSubDivisions(uniqueSubDivisions);
            }
        }
    }, [hierarchy, cfcLevelId, subDivisions]);
    const DownloadPdf = async (print) => {
        return new Promise((resolve, reject) => {
            let offName = officeName;
            let dateToPrint = convertDate(new Date);
            const reportTitle = dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
                ? `Daily Escalated Complaints Report for (${offName})`
                : `Escalated Complaints for (${offName}) from ${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`;
            const headers = [
                [
                    { content: 'Sr No.' },
                    { content: 'Complaint ID' },
                    { content: 'Ref No.' },
                    { content: 'Name' },
                    { content: 'Address' },
                    { content: 'Phone No.' },
                    { content: 'Complaint Type' },
                    { content: 'Registered At' },
                    { content: 'Escalated To' },
                    { content: 'Elapsed Time' },

                ],
            ];

            const body = [];

            if (powerComplaints && powerComplaints.length > 0) {
                const sortedComplaints = [...powerComplaints].sort((a, b) => a.Serial_No - b.Serial_No);
                sortedComplaints.forEach((item) => {
                    body.push([
                        item.Serial_No || '-',
                        item.EOpsTrackingId || '-',
                        item.RefNo || '-',
                        item.Name || '-',
                        item.Address || '-',
                        item.Mobile || '-',
                        item.ComplaintType || '-',
                        item.RegisteredAt ? formatDate(item.RegisteredAt) : '-',
                        item.EscalatedTo || '-',
                        item.elapsedTime || '-',
                    ]);
                });
            } else {
                body.push([{ content: 'No Data Found', styles: { halign: 'center', fontSize: 10, fontStyle: 'bold', fillColor: [255, 255, 255], textColor: [255, 0, 0] } }]);
            }

            const pdf = new jsPDF('landscape', 'mm', 'a4', { compressPdf: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const logoWidth = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 25 : 30;
            const logoHeight = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 20 : 10;
            pdf.addImage(getLogo(companyCode), 'PNG', 15, 5, logoWidth, logoHeight);

            const eOpsLogoWidth = 20;
            const eOpsLogoHeight = 8;
            const eOpsLogoXPosition = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 43 : 17;
            pdf.addImage(eOpsLogo, 'PNG', eOpsLogoXPosition, companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 12 : 17, eOpsLogoWidth, eOpsLogoHeight);

            pdf.setFontSize(10);
            pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
            pdf.text('Name: ' + name, pageWidth - 65, 17);
            pdf.text('Designation: ' + roleName, pageWidth - 65, 22);

            pdf.setFontSize(12);
            pdf.text(getCompanies(companyCode), pageWidth / 2, 12, { align: 'center' });
            pdf.text(`Escalated Complaints Report`, pageWidth / 2, 18, { align: 'center' });
            pdf.setFontSize(10);
            pdf.text(reportTitle, pageWidth / 2, 25, { align: 'center' });

            pdf.autoTable({
                startY: 28,
                head: headers,
                body: body,
                styles: {
                    cellPadding: 1,
                    fontSize: 8,
                    halign: 'center',
                    lineWidth: 0.25,
                    lineColor: 'white',
                },
                margin: { top: 2 },
                theme: 'striped',
                headStyles: { valign: 'middle' },
                bodyStyles: {
                    halign: 'center',
                },
                columnStyles: {
                    0: { halign: 'left' },
                    3: { halign: 'left' },
                    4: { halign: 'left' },
                },
                didParseCell: (data) => {
                    if (data.row.raw[0]?.content === 'No Data Found') {
                        data.cell.colSpan = headers[0].length;
                    }
                },
            });

            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                const pageNumberText = `Page ${i} of ${totalPages}`;
                pdf.setFontSize(10);
                pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
            }
            if (print) {
                const safeFileName = reportTitle.replace(/[:/\\]/g, '-').replace(/\s+/g, '-');
                pdf.save(`${safeFileName}.pdf`);
            } else {
                resolve(pdf);
            }
        });
    };
    const printPDF = async () => {
        let pdf = await DownloadPdf(false);
        const pdfUrl = pdf.output('bloburl');

        // Create an iframe
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.src = pdfUrl;
        document.body.appendChild(iframe);

        // Create a cancel button
        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Cancel';
        cancelButton.style.position = 'fixed';
        cancelButton.style.top = '20px';
        cancelButton.style.right = '20px';
        cancelButton.style.padding = '10px 20px';
        cancelButton.style.backgroundColor = '#ff4d4d';
        cancelButton.style.color = 'white';
        cancelButton.style.border = 'none';
        cancelButton.style.borderRadius = '5px';
        cancelButton.style.cursor = 'pointer';
        document.body.appendChild(cancelButton);

        // Print the PDF when the iframe loads
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        };

        // Remove iframe and cancel button when cancel button is clicked
        cancelButton.addEventListener('click', () => {
            if (iframe.parentNode) {
                document.body.removeChild(iframe);
            }
            if (cancelButton.parentNode) {
                document.body.removeChild(cancelButton);
            }
        });
    };
    const exportToExcel = () => {
        const headers = [
            'Sr No.',
            'Complaint ID',
            'Ref No.',
            'Name',
            'Address',
            'Phone No.',
            'Complaint Type',
            'Registered At',
            'Escalated To',
            'Elapsed Time'
        ];

        const data =
            powerComplaints && powerComplaints.length > 0
                ? [...powerComplaints]
                    .sort((a, b) => a.Serial_No - b.Serial_No)
                    .map(item => [
                        item.Serial_No || '-',
                        item.EOpsTrackingId || '-',
                        item.RefNo || '-',
                        item.Name || '-',
                        item.Address || '-',
                        item.Mobile || '-',
                        item.ComplaintType || '-',
                        item.RegisteredAt ? formatDate(item.RegisteredAt) : '-',
                        item.EscalatedTo || '-',
                         item.elapsedTime || '-',
                    ])
                : [['No Data Found', '-', '-', '-', '-', '-', '-']];

        const worksheetData = [headers, ...data];

        const reportTitle = dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
            ? `Daily Escalated Complaints Report for (${officeName})`
            : `Escalated Complaints for (${officeName}) from ${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`;



        const ws = XLSX.utils.aoa_to_sheet([[reportTitle], [''], ...worksheetData]);

        ws['!cols'] = [
            { wch: 20 },
            { wch: 15 },
            { wch: 20 },
            { wch: 30 },
            { wch: 15 },
            { wch: 20 },
            { wch: 20 },
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Escalated Complaints');

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const safeFileName = reportTitle.replace(/[:/\\]/g, '-').replace(/\s+/g, '-');
        saveAs(new Blob([wbout]), `${safeFileName}.xlsx`);
    };

     const currentFilters = {
   dateFrom,
      dateTo,
      pageNumber, pageSize, officeCode, complaintStatus
    };
    
    useEffect(() => {
      if (lastAppliedFilters === null) {
        setIsGoDisabled(false);
        return;
      }
    
      const hasChanged = JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
      setIsGoDisabled(!hasChanged); 
    }, [
      dateFrom,
      dateTo,
      pageNumber, pageSize, officeCode, complaintStatus
    ]);
    
    const handleGoClick = () => {
    fetchData(pageNumber, pageSize, officeCode, complaintStatus, convertDateYYYYMMDD(dateFrom), convertDateYYYYMMDD(dateTo)) 
    
      setLastAppliedFilters({ ...currentFilters });
    
      setIsGoDisabled(true);
    };
     const resetTableData = () => {
  setPowerComplaints([]);
  setPowerComplaintsToDataGrid([]);
    };

     const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

    return (
        <>
            {/* Applications Table */}
            <Box className='form-box'>
                <h3 className='page-title'>Escalated Complaints</h3>
                <div className='reports-container' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '15px' }}>
                    <div className="filter-fields" style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'flex-start', marginBottom: '10px' }}>
                        <div className='field-container'>
                            <Typography sx={{ color: 'gray' }} className='field-label'> Date From</Typography>
                            <input
                                type='date'
                                style={{ backgroundColor: 'white', border: '1px solid #d3d3d3', borderRadius: '5px' }}
                                className='date-field'
                                value={dateFrom}
                                onChange={(e) => { setDateFrom(e.target.value);  }}
                            />
                        </div>
                        <div className='field-container'>
                            <Typography sx={{ color: 'gray' }} className='field-label'> Date To</Typography>
                            <input
                                style={{ backgroundColor: 'white', border: '1px solid #d3d3d3', borderRadius: '5px' }}
                                type='date'
                                className='date-field'
                                  max={new Date().toISOString().split("T")[0]}
                                value={dateTo}
                                onChange={(e) => { setDateTo(e.target.value);  }}
                            />
                        </div>
                        {code == 10 && (
                            <div className="field-container">
                                <Typography className="field-label" sx={{ color: 'gray' }}>Company</Typography>
                                <select
                                    className="dropdown-field"
                                    style={{ backgroundColor: 'white', border: '1px solid #d3d3d3', borderRadius: '5px' }}
                                    value={selectedCompanyCode}
                                    onChange={(e) => { handleChangeCompany(e);  }}
                                >
                                    <option value="10">Select Company</option>
                                    <option value="11">LESCO</option>
                                    <option value="12">GEPCO</option>
                                    <option value="13">FESCO</option>
                                    <option value="14">IESCO</option>
                                    <option value="15">MEPCO</option>
                                    <option value="26">PESCO</option>
                                    <option value="27">HAZECO</option>
                                    <option value="37">HESCO</option>
                                    <option value="38">SEPCO</option>
                                    <option value="48">QESCO</option>
                                    <option value="59">TESCO</option>
                                </select>
                            </div>
                        )}
                        {hierarchy <= 2 && (
                            <div className="field-container">
                                <Typography className="field-label" sx={{ color: 'gray' }}>Circle</Typography>
                                <select
                                    className="dropdown-field"
                                    style={{ backgroundColor: 'white', border: '1px solid #d3d3d3', borderRadius: '5px' }}
                                    value={circleCode || ''}
                                    onChange={(e) => { handleCircleChange(e);  }}
                                >
                                    <option value="">All Circle</option>
                                    {filteredCircles.map((circle) => (
                                        <option key={circle.circleCode} value={circle.circleCode}>
                                            {circle.circleName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        {hierarchy <= 3 && (
                            <div className="field-container">
                                <Typography className="field-label" sx={{ color: 'gray' }}>Division</Typography>
                                <select
                                    className="dropdown-field"
                                    style={{ backgroundColor: 'white', border: '1px solid #d3d3d3', borderRadius: '5px' }}
                                    value={selectedDivision || ''}
                                    onChange={(e) => { handleDivisionChange(e);  }}
                                    disabled={!circleCode}
                                >
                                    <option value="">All Division</option>
                                    {filteredDivisions.map((division) => (
                                        <option key={division.divisionCode} value={division.divisionCode}>
                                            {division.divisionName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        {hierarchy <= 4 && (
                            <div className="field-container">
                                <Typography className="field-label" sx={{ color: 'gray' }}>Sub-Division</Typography>
                                <select
                                    className="dropdown-field"
                                    style={{ backgroundColor: 'white', border: '1px solid #d3d3d3', borderRadius: '5px' }}
                                    value={selectedSubDivision || ''}
                                    onChange={(e) => { handleSubDivisionChange(e);  }}
                                    disabled={!selectedDivision}
                                >
                                    <option value="">All Sub-Division</option>
                                    {filteredSubDivisions.map((subDivision) => (
                                        <option key={subDivision.subDivisionCode} value={subDivision.subDivisionCode}>
                                            {subDivision.subDivisionName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginTop: '10px' }}
                            onClick={handleGoClick}
  disabled={isGoDisabled || viewBackdrop}
                        >
                            Go
                        </Button>

                    </div>
                    <div className="export-button-container" style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                            <div
                    onClick={() => {
                      if (powerComplaints.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (powerComplaints.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (powerComplaints.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>
                    </div>
                </div>
                <div className="filter-fields" style={{ fontSize: '20px', marginBottom: '10px', textAlign: 'center', backgroundColor: '#d5e5ff', color: 'black' }}>
                    {dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
                        ? `Daily Escalated Complaints Report for (${officeName})`
                        : `Escalated Complaints for (${officeName}) from ${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`}
                </div>
                <Box className='application-table'>
                    <div className='div-datagrid' >
                        <BasicTable
                            data={powerComplaintsToDataGrid}
                            columns={tblColumns}
                            handleRowClick={(params) => { handleRowClick(params.complaintId) }}
                            sx={tableStyle}
                            rowHeight={37.5}
                            pageSize={20}
                            rowsPerPageOptions={[18, 30, 60]}
                            nextPage={handleNextPage}
                            firstPage={handleFirstPage}
                            lastPage={handleLastPage}
                            previousPage={handlePreviousPage}
                            totalPages={totalPages}
                            totalRecords={totalRecords}
                            currentPage={pageNumber}
                            rowsPageOption={false}
                            getRowStyle={(params) => {
                                return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                            }}
                            isLoading={isLoading}
                        />
                    </div>
                </Box>
            </Box>

            {/* Main Popup */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'false'}
                className='main-dialog'
            >
                <DialogTitle className="dialog-title" >
                    <Grid container spacing={1} className='headercontainer'>
                        <Grid item lg={2}>
                        </Grid>
                        <Grid item lg={8} className='applicationTitleGrid'>
                            <Typography className="applicationTitleText">Power Complaint
                            </Typography>
                        </Grid>
                        <Grid item lg={2} className="closeIcon">
                            <CloseIcon id="clearPopup" onClick={handleClose} sx={{ color: 'white' }} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: 'white' }}>
                    <DialogContentText className="dialog-content" >
                        <Grid container spacing={1} className='headercontainer'>
                            <Grid item lg={12} className='status-bar'>
                                <StepProgressBar array={ComplaintStatusBarArray} applicationProgressId={1} objection={0} pageName='Power Complaints' />
                            </Grid>
                            <Grid item lg={12} className='application-details'>
                                <Grid container spacing={2} className="first-row">
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Complaint Id.</p><p className='prop-detail'>{dialogRowData.complaintId ? dialogRowData.complaintId : '-'}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Complainant Name</p><p className='prop-detail'>{dialogRowData.name ? dialogRowData.name : '-'}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Complainant Ref No.</p><p className='prop-detail'>{dialogRowData.refNo ? dialogRowData.refNo : '-'}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Phone No.</p><p className='prop-detail'>{dialogRowData.phoneNo ? dialogRowData.phoneNo : '-'}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Subdivision</p><p className='prop-detail'>{dialogRowData.subDivisionCode ? subdivisionName(dialogRowData.subDivisionCode) : '-'}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Meter Phase</p><p className='prop-detail'>{dialogRowData.meterPhase ? dialogRowData.meterPhase : '-'}</p>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item lg={12} className='application-details' sx={{ marginTop: '15px' }}>
                                <Grid container spacing={2} className="first-row">
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Created On</p><p className='prop-detail'>{complainDetails.createdOn ? complainDetails.createdOn : '-'}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Complaint Status</p><p className='prop-detail'>{complainDetails.esc_status ? complainDetails.esc_status : '-'}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Complaint Delay Status</p><p className='prop-detail'>{complainDetails.complainStatus ? complainDetails.complainStatus : '-'}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Complaint Source</p><p className='prop-detail'>{complainDetails.complainSource ? complainDetails.complainSource : '-'}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Compliant Detail</p><p className='prop-detail'>{complainDetails.complaintDetail ? complainDetails.complaintDetail : '-'}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>ESC. Level</p><p className='prop-detail'>{complainDetails.escLevel ? complainDetails.escLevel : '-'}</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent >
                <DialogActions className="dialog-action">
                </DialogActions>
            </Dialog >

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default EscalatedComplaints;